<template>
  <div class="stepper">
    <template v-for="(step, index) in steps">
      <div :class="[
        'stepper-step',
        {
          'stepper-step-first': (index === 0) ,
          'stepper-step-last': index === steps.length-1,
          'stepper-step-active': index < currentStep,
          'stepper-step-current': index === currentStep
        }
      ]" :key="index">
        <div v-if="index > 0" class="stepper-step-line-left" />
        <div v-if="index < steps.length-1" class="stepper-step-line-right" />
        <div class="stepper-step-content">
          <div class="stepper-step-label">{{steps[index]}}</div>
          <div class="stepper-step-circle">
            {{ (index + 1) }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Stepper',

  props: {
    steps: {
      type: Array,
      required: true
    },

    currentStep: {
      type: Number,
      default: 0
    }
  }
}
</script>
